import { datadogLogs } from "@datadog/browser-logs"
import { cloneDeep } from "lodash"
import { replaceObjVal } from "./libs/replaceObjValue"

const DD_CLIENT_TOKEN = 'pub775a66fb22bd2d793fbd55468af2284b'
const DD_CLIENT_SITE = 'datadoghq.com'
const DD_SERVICE_NAME = 'dream-ui'

datadogLogs.init({
  clientToken: DD_CLIENT_TOKEN,
  site: DD_CLIENT_SITE,
  forwardErrorsToLogs: true,
  env: process.env.NODE_ENV || 'error',
  forwardConsoleLogs: ['error'],
  sampleRate: 100,
  service: DD_SERVICE_NAME,
  beforeSend: (log) => {
    log = cloneDeep(log)
    for (const prop in ['password', 'patient']) {
      replaceObjVal(log, prop, '***')
    }
  }
})


const config = {
  cognito: {
    IDP_DOMAIN: 'xsolis-xdam',
    IDP_REDIRECT_URL: 'https://dream.xsolis.com/sso',
    USER_POOL_ID: 'us-east-1_Y2be4I9LP',
    APP_CLIENT_ID: '6e5s3b97qk5frmom90573n7b3p',
    REGION: 'us-east-1'
  },
  HOST: 'wchel7znci.execute-api.us-east-1.amazonaws.com',
  ENV: 'prod',
  TIMEOUT: 12000000
}

config.cognito.IDP_URL = `https://${config.cognito.IDP_DOMAIN}.auth.us-east-1.amazoncognito.com/login?client_id=${config.cognito.APP_CLIENT_ID}&redirect_uri=${config.cognito.IDP_REDIRECT_URL}&response_type=code&state=STATE`

export default config
